import React from "react";
import { motion } from "framer-motion";
import { useState } from "react";
import {accordionData} from "../constants";

import "react-vertical-timeline-component/style.min.css";

import { styles } from "../styles";

import { SectionWrapper } from "../hoc";
import { textVariant } from "../utils/motion";


const FAQ = () => {

  const [Active, setActive] = useState(0);
  const handleClick = (id) => {
    setActive(id);
  }

  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={`${styles.sectionSubText} text-center`}>
          FAQs
        </p>
        <h2 className={`${styles.sectionHeadText} text-center`}>
          You may want to know
        </h2>
      </motion.div>

      <div className='mt-20'>
        {accordionData.map((accord,i) => (
            <>
            <a id={i}  className="" onClick={() => { handleClick(i)}}>
              <div className="bg-white mt-3 font-semibold text-xl text-primary text-start  p-5 flex justify-between">
                <h1>{accord.title}</h1>
                <img className={Active === i? "rotate-180 transition-all" : "transition-all"}  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCA3LjMzbDIuODI5LTIuODMgOS4xNzUgOS4zMzkgOS4xNjctOS4zMzkgMi44MjkgMi44My0xMS45OTYgMTIuMTd6Ii8+PC9zdmc+"></img>
                </div>
            <p id={i} className={Active === i? "font-normal text-primary text-lg p-4 bg-white" : "hidden"} >{accord.content}</p>
            </a>
            </>
        ))}
      </div> 
    </>
  );
};

export default SectionWrapper(FAQ, "faq");
